/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Supplier API
 * Areeb Supplier REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AddCatalogItemRequestOrderLimit } from './AddCatalogItemRequestOrderLimit';
import {
    AddCatalogItemRequestOrderLimitFromJSON,
    AddCatalogItemRequestOrderLimitFromJSONTyped,
    AddCatalogItemRequestOrderLimitToJSON,
} from './AddCatalogItemRequestOrderLimit';

/**
 * 
 * @export
 * @interface AddCatalogItemRequest
 */
export interface AddCatalogItemRequest {
    /**
     * Product ID to add
     * @type {number}
     * @memberof AddCatalogItemRequest
     */
    productId: number;
    /**
     * Price for this product
     * @type {number}
     * @memberof AddCatalogItemRequest
     */
    price: number;
    /**
     * Currency
     * @type {string}
     * @memberof AddCatalogItemRequest
     */
    currency: AddCatalogItemRequestCurrencyEnum;
    /**
     * Custom description
     * @type {string}
     * @memberof AddCatalogItemRequest
     */
    description?: string;
    /**
     * Lead time in days
     * @type {number}
     * @memberof AddCatalogItemRequest
     */
    leadTime?: number;
    /**
     * Whether in stock
     * @type {boolean}
     * @memberof AddCatalogItemRequest
     */
    inStock?: boolean;
    /**
     * Available quantity
     * @type {number}
     * @memberof AddCatalogItemRequest
     */
    stockQuantity?: number;
    /**
     * Minimum order quantity
     * @type {number}
     * @memberof AddCatalogItemRequest
     */
    minimumOrderQty?: number;
    /**
     * Maximum order quantity
     * @type {number}
     * @memberof AddCatalogItemRequest
     */
    maximumOrderQty?: number;
    /**
     * 
     * @type {AddCatalogItemRequestOrderLimit}
     * @memberof AddCatalogItemRequest
     */
    orderLimit?: AddCatalogItemRequestOrderLimit;
}


/**
 * @export
 */
export const AddCatalogItemRequestCurrencyEnum = {
    Egp: 'EGP',
    Sar: 'SAR',
    Mad: 'MAD'
} as const;
export type AddCatalogItemRequestCurrencyEnum = typeof AddCatalogItemRequestCurrencyEnum[keyof typeof AddCatalogItemRequestCurrencyEnum];


/**
 * Check if a given object implements the AddCatalogItemRequest interface.
 */
export function instanceOfAddCatalogItemRequest(value: object): value is AddCatalogItemRequest {
    if (!('productId' in value) || value['productId'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    return true;
}

export function AddCatalogItemRequestFromJSON(json: any): AddCatalogItemRequest {
    return AddCatalogItemRequestFromJSONTyped(json, false);
}

export function AddCatalogItemRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddCatalogItemRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'productId': json['productId'],
        'price': json['price'],
        'currency': json['currency'],
        'description': json['description'] == null ? undefined : json['description'],
        'leadTime': json['leadTime'] == null ? undefined : json['leadTime'],
        'inStock': json['inStock'] == null ? undefined : json['inStock'],
        'stockQuantity': json['stockQuantity'] == null ? undefined : json['stockQuantity'],
        'minimumOrderQty': json['minimumOrderQty'] == null ? undefined : json['minimumOrderQty'],
        'maximumOrderQty': json['maximumOrderQty'] == null ? undefined : json['maximumOrderQty'],
        'orderLimit': json['orderLimit'] == null ? undefined : AddCatalogItemRequestOrderLimitFromJSON(json['orderLimit']),
    };
}

export function AddCatalogItemRequestToJSON(value?: AddCatalogItemRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'productId': value['productId'],
        'price': value['price'],
        'currency': value['currency'],
        'description': value['description'],
        'leadTime': value['leadTime'],
        'inStock': value['inStock'],
        'stockQuantity': value['stockQuantity'],
        'minimumOrderQty': value['minimumOrderQty'],
        'maximumOrderQty': value['maximumOrderQty'],
        'orderLimit': AddCatalogItemRequestOrderLimitToJSON(value['orderLimit']),
    };
}

